<template>
  <div
    class="flex flex-col max-w-full mx-auto md:space-x-2 md:flex-row"
    v-if="property"
  >
    <div class="relative h-full md:w-8/12">
      <div @click="openPhotoModal()" class="cursor-pointer">
        <img :src="property.photos[0]" class="w-full md:h-[550px]" alt="" />
      </div>

      <TagsView />
      <PhotosAndMap :property="property" :address="property.address" />
    </div>
    <div class="hidden md:w-4/12 md:flex">
      <div class="flex flex-col md:w-full md:space-y-2">
        <img
          @click="openPhotoModal()"
          :src="property.photos[1]"
          v-if="property.photos[1]"
          class="w-full h-[271px] cursor-pointer"
          alt=""
        />
        <img
          @click="openPhotoModal()"
          :src="property.photos[2]"
          v-if="property.photos[2]"
          class="w-full h-[271px] cursor-pointer"
          alt=""
        />
      </div>
    </div>
    <PhotoModal
      :photos="property.photos"
      :showViewModal="showPhotoModal"
      @closePhotoModal="closePhotoModal"
    />
  </div>
</template>
<script>
import { ref } from "vue";
import TagsView from "@/features/properties/components/TagsView.vue";
import PhotosAndMap from "@/features/property/PhotosAndMap.vue";
import PhotoModal from "./PhotosSliderModal.vue";
export default {
  components: {
    TagsView,
    PhotosAndMap,
    PhotoModal,
  },
  props: {
    property: Object,
  },
  setup() {
    const showPhotoModal = ref(false);

    const openPhotoModal = () => {
      showPhotoModal.value = true;
    };

    const closePhotoModal = () => {
      showPhotoModal.value = false;
    };

    return {
      showPhotoModal,
      openPhotoModal,
      closePhotoModal,
    };
  },
};
</script>
